const messageTypes = {
	TOASTS: {
		CLEAR: 'CLEAR_TOASTS',
		CLEAR_NON_PERSISTANTS: 'CLEAR_NON_PERSISTANTS_TOASTS',
		PUSH: {
			ITEM: 'PUSH_TOAST',
			SUCCESS: 'PUSH_SUCCESS_TOAST',
			ERROR: 'PUSH_ERROR_TOAST',
			WARNING: 'PUSH_WARNING_TOAST',
			INFO: 'PUSH_INFO_TOAST',
		},
		POP: {
			ITEM: 'POP_TOAST',
			SUCCESS: 'POP_SUCCESS_TOAST',
			ERROR: 'POP_ERROR_TOAST',
			WARNING: 'POP_WARNING_TOAST',
			INFO: 'POP_INFO_TOAST',
		},
	},
};

export default messageTypes;
